import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
export function ProductOverview() {
  const tomos = [{
    emoji: '🟠',
    title: 'TOMO 1',
    level: 'El ADN de la Masa',
    content: 'La base de todo. Acá no hay secretos. Masa base paso a paso explicada para principiantes absolutas.'
  }, {
    emoji: '🟡',
    title: 'TOMO 2',
    level: 'Master de Glaseados, Colores y Toppings',
    content: 'Las minidonas que la gente no puede dejar de fotografiar. Glaseados paso a paso: básico, chocolate, ganache, espejo.'
  }, {
    emoji: '🟢',
    title: 'TOMO 3',
    level: 'Minidonas Saladas: El Sabor Argento',
    content: 'El diferencial que muy pocos ofrecen. Tu ventaja competitiva. Masa salada base con sus variantes.'
  }, {
    emoji: '🔵',
    title: 'TOMO 4',
    level: 'Minidonas Fritas',
    content: 'Las que más se venden en ferias y eventos. La versión irresistible. Masa levada paso a paso con sus tiempos exactos.'
  }, {
    emoji: '🟣',
    title: 'TOMO 5',
    level: 'Packaging y Presentación',
    content: 'Porque la primera venta entra por los ojos. Tipos de cajas y materiales de packaging disponibles en Argentina.'
  }, {
    emoji: '🔴',
    title: 'TOMO 6',
    level: 'Tu Negocio en Pesos',
    content: 'El tomo que convierte una hobbysta en una emprendedora real. Costos reales: harina, huevos, aceite, packaging — todo calculado.'
  }];
  const includes = ['Recetas y técnicas listas para aplicar', 'Explicaciones paso a paso aptas para principiantes', 'Tablas, checklists y registros descargables', 'Adaptado al contexto argentino (ingredientes, precios, proveedores)', 'Lenguaje claro y directo — sin términos de pastelería profesional'];
  return <section className="w-full bg-white py-8 md:py-16" data-id="element-187">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-188">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-189">
          <div className="text-center mb-6 md:mb-12" data-id="element-190">
            <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-2 md:mb-4" data-id="element-191">
              🏆 MEGA PACK EMPRENDE MINIDONAS 360
            </h2>
            <p className="text-xl md:text-2xl text-orange-500 font-semibold mb-1 md:mb-2" data-id="element-192">
              6 Tomos + 3 Bonos — Masa → Negocio en Pesos
            </p>
            <p className="text-2xl md:text-3xl font-bold text-gray-900" data-id="element-193">
              Todo resuelto. Paso a paso. Desde cero.
            </p>
          </div>

          <div className="mb-8 md:mb-12" data-id="element-194">
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 md:mb-8 text-center" data-id="element-195">
              📚 LOS 6 TOMOS COMPLETOS
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-196">
              {tomos.map((tomo, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1,
              duration: 0.5
            }} className="bg-orange-50 border border-orange-200 rounded-lg p-6" data-id="element-197">
                  <div className="text-4xl mb-3" data-id="element-198">{tomo.emoji}</div>
                  <h4 className="text-lg font-bold text-gray-900 mb-2" data-id="element-199">
                    {tomo.title}
                  </h4>
                  <p className="text-orange-500 font-semibold mb-3" data-id="element-200">
                    {tomo.level}
                  </p>
                  <p className="text-gray-600 text-sm leading-relaxed" data-id="element-201">
                    {tomo.content}
                  </p>
                </motion.div>)}
            </div>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-orange-50 border border-orange-200 rounded-lg p-6 md:p-8" data-id="element-202">
            <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 md:mb-6 text-center" data-id="element-203">
              Cada tomo incluye:
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4" data-id="element-204">
              {includes.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-205">
                  <CheckCircleIcon className="w-5 h-5 text-orange-500 flex-shrink-0 mt-0.5" data-id="element-206" />
                  <p className="text-gray-600" data-id="element-207">{item}</p>
                </div>)}
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}